import { sortingMethods } from '../../../../constants/table';
import CustomCell from '../../../../components/Table/CustomCell';

export const scriptExecutionDeviceTableColumnsOrder = [
  { name: 'fileName', styles: { wordBreak: 'break-word' } },
  { name: 'filePath', styles: { wordBreak: 'break-word' } },
  { name: 'sha256Hash', styles: { wordBreak: 'break-word' } },
  { name: 'userWriteable', styles: { wordBreak: 'break-word' } },
  { name: 'lastSeen' },
];

export const scriptExecutionDeviceTableHeadings = [
  {
    title: 'Script Name',
    name: 'fileName',
    hasSorting: false,
    width: '24%',
    sortMethod: sortingMethods.initial,
    field: 'FilterScriptExecutionResult',
    sortingCellField: 'FileName',
    sortFieldName: 'OrderQuery',
    Component: CustomCell,
  },
  {
    title: 'File Path',
    name: 'filePath',
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterScriptExecutionResult',
    sortingCellField: 'FilePath',
    sortFieldName: 'OrderQuery',
    width: '25%',
  },
  {
    title: 'SHA256 HASH',
    name: 'sha256Hash',
    hasSorting: false,
    width: '18%',
    sortMethod: sortingMethods.initial,
    field: 'FilterScriptExecutionResult',
    sortingCellField: 'Sha256Hash',
    sortFieldName: 'OrderQuery',
    Component: CustomCell,
  },
  {
    title: 'User Writeable',
    name: 'userWriteable',
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterScriptExecutionAffectedDevices',
    sortingCellField: 'UserWriteable',
    sortFieldName: 'OrderQuery',
    width: '20%',
  },
  {
    title: 'Last Seen',
    name: 'lastSeen',
    hasSorting: false,
    width: '18%',
    sortMethod: sortingMethods.initial,
    field: 'FilterScriptExecutionResult',
    sortingCellField: 'LastSeen',
    sortFieldName: 'OrderQuery',
    Component: CustomCell,
  },
];

